(() => {
  const aliases = {mercy: 'mercy-high-school', 'holy-family': 'holy-family-novi'};
  function initReview(root, pageUrl) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const labels = JSON.parse(root.querySelector('[data-review-labels]').textContent);
    const key = `mh-lookbook-v1:${root.dataset.collection}:${root.dataset.round}`;
    const cards = [...root.querySelectorAll('[data-product]')];
    const form = root.querySelector('form');
    const summary = root.querySelector('[data-summary]');
    const list = root.querySelector('[data-summary-list]');
    const feedback = root.querySelector('[data-feedback]');
    const submit = root.querySelector('[data-submit]');
    let state = {items: {}, general: ''};
    try {
      const saved = JSON.parse(localStorage.getItem(key));
      if (saved && saved.items && typeof saved.items === 'object' && !Array.isArray(saved.items)) state = saved;
    } catch {}
    const color = getComputedStyle(root).getPropertyValue('--lb-brand').trim();
    if (/^#[0-9a-f]{6}$/i.test(color)) {
      const channels = color.slice(1).match(/../g).map(c => parseInt(c, 16) / 255).map(c => c <= .04045 ? c / 12.92 : ((c + .055) / 1.055) ** 2.4);
      const luminance = channels[0] * .2126 + channels[1] * .7152 + channels[2] * .0722;
      root.style.setProperty('--lb-on-brand', luminance > .179 ? '#171717' : '#ffffff');
    }
    for (const card of cards) {
      const saved = state.items[card.dataset.product];
      if (!saved || typeof saved !== 'object') continue;
      const radio = [...card.querySelectorAll('input[type=radio]')].find(input => input.value === saved.decision);
      if (radio) radio.checked = true;
      card.querySelector('[data-note]').value = typeof saved.note === 'string' ? saved.note.slice(0, 1500) : '';
    }
    const general = root.querySelector('[data-general]');
    general.value = typeof state.general === 'string' ? state.general.slice(0, 3000) : '';
    const returnUrl = new URL(pageUrl);
    returnUrl.searchParams.delete('contact_posted');
    returnUrl.searchParams.set('contact_posted', 'true');
    returnUrl.hash = 'lookbook-summary';
    root.querySelector('[data-return-to]').value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
    function update(save = true) {
      const current = [];
      for (const card of cards) {
        const decision = card.querySelector('input:checked')?.value || 'pending';
        const item = {title: card.dataset.title, url: card.dataset.url, decision, note: card.querySelector('[data-note]').value};
        state.items[card.dataset.product] = item;
        current.push(item);
        card.dataset.decision = decision;
        card.querySelector('.lb-status').textContent = labels[decision];
        card.querySelector('[data-clear]').hidden = decision === 'pending';
      }
      const reviewed = current.filter(item => item.decision !== 'pending');
      root.querySelector('[data-progress]').textContent = `${reviewed.length} / ${current.length} ${labels.count}`;
      list.replaceChildren();
      for (const item of reviewed) {
        const row = document.createElement('p');
        row.textContent = `${item.title} — ${labels[item.decision]}`;
        list.append(row);
      }
      if (!reviewed.length) list.textContent = labels.empty;
      summary.value = `${root.dataset.name}\n${root.dataset.collection}\nRound: ${root.dataset.round}\n\n` + current.map(item => `${item.title} — ${labels[item.decision]}\n${item.url}${item.note ? '\n' + item.note : ''}`).join('\n\n');
      submit.disabled = reviewed.length === 0;
      state.general = general.value;
      if (save) {
        try {
          localStorage.setItem(key, JSON.stringify(state));
          root.querySelector('[data-save-status]').textContent = labels.saved;
        } catch { root.querySelector('[data-save-status]').textContent = labels.unsaved; }
      }
    }
    root.addEventListener('change', () => update());
    root.addEventListener('input', event => { if (event.target.matches('[data-note], [data-general]')) update(); });
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-clear]');
      if (!button) return;
      button.closest('[data-product]').querySelectorAll('input[type=radio]').forEach(input => { input.checked = false; });
      update();
    });
    form.addEventListener('submit', event => {
      update();
      if (submit.disabled) { event.preventDefault(); feedback.textContent = labels.required; }
    });
    root.querySelector('[data-copy]').addEventListener('click', async () => {
      update();
      try { await navigator.clipboard.writeText(summary.value + '\n\n' + general.value); feedback.textContent = labels.copied; }
      catch { summary.hidden = false; summary.readOnly = true; summary.focus(); summary.select(); feedback.textContent = labels.copy_error; }
    });
    root.querySelectorAll('.lb-pagination a').forEach(link => {
      const target = new URL(pageUrl);
      target.searchParams.set('page', new URL(link.href).searchParams.get('page') || '1');
      target.searchParams.delete('contact_posted');
      target.hash = 'lookbook-products';
      link.href = target.href;
    });
    update(false);
    if (window.Shopify?.captcha?.protect) window.Shopify.captcha.protect(form, () => {});
  }
  async function loadPage(shell) {
    if (shell.dataset.ready) return;
    shell.dataset.ready = 'true';
    const labels = JSON.parse(shell.querySelector('[data-shell-labels]').textContent);
    const url = new URL(location.href);
    const brand = aliases[url.searchParams.get('brand')] || url.searchParams.get('brand');
    const message = shell.querySelector('[data-load-message]');
    if (!brand || !/^[a-z0-9][a-z0-9-]{0,150}$/.test(brand)) { message.textContent = labels.missing; return; }
    const endpoint = new URL(`${shell.dataset.root}collections/${encodeURIComponent(brand)}`, location.origin);
    endpoint.searchParams.set('section_id', 'brand-review-lookbook');
    if (url.searchParams.has('preview_theme_id')) endpoint.searchParams.set('preview_theme_id', shell.dataset.theme);
    if (/^[1-9][0-9]*$/.test(url.searchParams.get('page') || '')) endpoint.searchParams.set('page', url.searchParams.get('page'));
    try {
      const response = await fetch(endpoint, {credentials: 'same-origin'});
      if (!response.ok) throw new Error('Collection unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const review = doc.querySelector('[data-lookbook-review]');
      if (!review) throw new Error('Review unavailable');
      shell.replaceChildren(review);
      initReview(review, url.href);
      if (url.searchParams.get('contact_posted') === 'true') {
        const notice = document.createElement('p');
        notice.className = 'lb-success'; notice.setAttribute('role', 'status'); notice.textContent = labels.success;
        review.querySelector('.lb-review').prepend(notice);
      }
      if (url.hash === '#lookbook-summary' || url.hash === '#lookbook-products') document.querySelector(url.hash)?.scrollIntoView();
    } catch { message.textContent = labels.error; }
  }
  document.querySelectorAll('[data-lookbook-page]').forEach(loadPage);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-lookbook-page]').forEach(loadPage));
})();
